<template>
  <div>
    <!-- TABELA DE LEILÕES -->
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Logs</h3>
      </div>
      <div class="card-body table-responsive p-0">
        <table class="table table-hover text-nowrap" style="position: relative">
          <thead>
            <tr>
              <th>Seq</th>
              <th>Id</th>
              <th>Alterações</th>
              <th>Evento</th>
              <th>Causado por</th>
              <th>Data</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(log, index) in logs" :key="log">
              <td data-label="Seq">{{ index + 1 }}</td>
              <td data-label="Id">{{ log.id }}</td>
              <td data-label="Alterações"><div v-html="getAlteracoes(log, index)"></div></td>
              <td data-label="Evento">{{ log.event }}</td>
              <td data-label="Causado por">{{ log.causer_type }} - ID {{ log.causer_id }}</td>
              <td data-label="Causado por">{{ formatDate(log.created_at) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!--
      <div class="card-footer clearfix">
         TOTAIS  
        <div style="font-size: 13px" class="float-left" aria-live="polite">
          Exibindo do {{ inicio + 1 }} ao {{ inicio + leiloes.length }}
          <p>Total {{ total }}</p>
        </div>

        <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

        <select @change="alterarQtdPagina()" class="float-left card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
          <option :value="25">25</option>
  <option :value="50">50</option>
  <option :value="100">100</option>
  <option :value="200">200</option>
        </select>

        <div class="card-tools">
          <div class="input-group input-group-sm" style="width: 150px"></div>
        </div>  -->

      <!-- PAGINAÇÃO
        <ul class="pagination pagination-sm m-0 float-right">
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&laquo;</a></li>

          <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
            <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
              {{ pagina }}
            </a>
          </li>

          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&raquo;</a></li>
        </ul>
          
      </div>-->
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert.js";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment, { relativeTimeThreshold } from "moment";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  props: ["logs"],

  mixins: [sweetAlert, Swal, AuxController],

  components: [Loading],

  data() {
    return {
      isLoading: false,
      leilao_selecionado: "",
      filtro: "",
      paginas: [],
      inicio: 0,
      total: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      leiloes: [],
      cidades: [],
      id: "",
      estado: "",
      cidade: "",
      comitente: "",
      titulo: "",
      descricao: "",
      local: "",
      tipo: "",
      teste: 0,
      executado: "",
      processo: "",
    };
  },

  mounted() {
    console.log(this.logs);

    //this.buscarLeiloes();
  },

  methods: {
    getAlteracoes(log, indice) {
      let alteracoes = "";

      if (indice + 1 < this.logs.length) {
        console.log("Entrou no primeiro IF");

        let jsonAtual = JSON.parse(log.properties);
        let jsonAnterior = JSON.parse(this.logs[indice + 1].properties);

        let keys = Object.keys(jsonAtual);

        let primeiro = true;

        for (let i = 0; i < keys.length; i++) {
          jsonAtual[keys[i]];

          //CASO O JSON ANTERIOR POSSUA ESSA KEY
          if (jsonAnterior[keys[i]] != null) {
            //CASO A KEY SEJA DIFERENTE DA ATUAL

            console.log("Key " + keys[i]);
            console.log("Comparando " + jsonAtual[keys[i]]);
            console.log("Com " + jsonAnterior[keys[i]]);
            console.log("\n");

            if (jsonAtual[keys[i]] != jsonAnterior[keys[i]]) {
              if (!primeiro) {
                alteracoes = alteracoes + "<br/>";
              }
              alteracoes = alteracoes + "<b>" + keys[i] + "<b/>: <br/>De: " + jsonAnterior[keys[i]] + "<br/>Para: " + jsonAtual[keys[i]] + "<br/>";
              primeiro = false;
              console.log("Entrou no IFF");
            } else {
              console.log("Entrou no ELSE");
            }
          } else {
            console.log("NÃO POSSUI A KEY");
            if (jsonAtual[keys[i]] != null) {
              console.log("NOT NULL");
              if (!primeiro) {
                alteracoes = alteracoes + "<br/>";
              }

              alteracoes = alteracoes + "<b>" + keys[i] + "<b/>: <br/>De:<br/>Para: " + jsonAtual[keys[i]] + "<br/>";
              primeiro = false;
            }
          }
        }
      }

      return alteracoes;
    },

    hideMenu() {
      let newMenu = document.getElementById("newMenu");
      newMenu.style.visibility = "hidden";
    },

    onRightClick(event, leilao) {
      this.leilao_selecionado = leilao;

      let newMenu = document.getElementById("newMenu");
      let x = event.clientX - 300;
      let y = event.pageY - 250;

      let winWidth = window.innerWidth;
      let cmWidth = newMenu.offsetWidth;

      x = event.clientX > winWidth - cmWidth ? winWidth - cmWidth - 300 : x;

      console.log("X depois " + x);

      newMenu.style.top = y + "px";
      newMenu.style.left = x + "px";
      newMenu.style.visibility = "visible";
    },

    changeStatus(leilao, atual) {
      console.log(leilao);

      let data = {
        leilao_id: leilao.id,
        leilao_oculto: this.convertToTiny(leilao.leilao_oculto),
        leilao_retirado: this.convertToTiny(leilao.leilao_retirado),
        leilao_encerrado: this.convertToTiny(leilao.leilao_encerrado),
        leilao_suspenso: this.convertToTiny(leilao.leilao_suspenso),
      };

      console.log(data);

      axios
        .post(`/admin/leilao/atualizar_status`, data)
        .then((response) => {
          this.showSuccessMessage("Status atualizado");

          //window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    handler() {
      alert("Right!");
    },

    getUrlFotos(leilao) {
      if (leilao.lotes && leilao.lotes.length) {
        return "/admin/fotos/" + leilao.lotes[0].id + "";
      }
    },

    getUrlLogs(leilao) {
      return "/admin/leilao/" + leilao.id + "/logs";
    },

    getUrlDocumentos(leilao) {
      return "/admin/documentos/" + leilao.id + "";
    },

    getUrlListarLotes(leilao) {
      return "/admin/leilao/" + leilao.id + "/lotes";
    },

    getUrlAddLote(leilao) {
      return "/admin/leilao/" + leilao.id + "/lotes/cadastrar_lote";
    },

    limparFiltros() {
      this.id = "";
      this.estado = "";
      this.cidade = "";
      this.comitente = "";
      this.titulo = "";
      this.descricao = "";
      //this.local = "EXCLUSIVAMENTE ONLINE";
      this.local = "";
      this.tipo = "";
      this.teste = 0;
      this.executado = "";
      this.processo = "";

      this.buscarLeiloes();
    },

    calcularValor(created_at) {
      let dataReferencia = this.formatToCompare(new Date());
      let data = this.formatToCompare(created_at);

      var duration = moment.duration(dataReferencia.diff(data));
      var hours = duration.asHours();

      if (hours < 1) {
        var min = duration.asMinutes();
        return ~~min + " min.";
      } else if (hours >= 24) {
        var days = duration.asDays();
        return ~~days + " dias";
      } else {
        return ~~hours + " horas";
      }
    },

    visualizar(leilao) {
      this.leilao_selecionado = leilao;
    },

    formatToCompare(date) {
      return moment(date);
    },

    convertTiny(value) {
      if (value == 0) {
        return "Não";
      } else {
        return "Sim";
      }
    },

    convertToTiny(value) {
      if (value) {
        return 1;
      } else {
        return 0;
      }
    },

    getUrlEdit(leilao) {
      return "/admin/leilao/" + leilao.id;
    },

    show(leilao) {
      this.leilao_selecionado = leilao;
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas.length && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarLeiloes();
      }
    },

    buscarCidades() {
      this.isLoading = true;

      let data = {
        estado_id: this.estado,
      };

      axios
        .post(`/admin/endereco/cidades_por_estado`, data)
        .then((response) => {
          this.cidades = response.data.cidades;

          console.log(response.data);

          this.isLoading = false;

          this.buscarLeiloes();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    buscarLeiloes() {
      this.isLoading = true;

      let data = {
        id: this.id,
        estado_id: this.estado,
        cidade_id: this.cidade,
        comitente_id: this.comitente,
        titulo: this.titulo,
        descricao: this.descricao,
        local: this.local,
        tipo: this.tipo,
        teste: this.teste,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
        executado: this.executado,
        processo_id: this.processo.id,
      };

      console.log(data);

      axios
        .post(`/admin/leilao/search`, data)
        .then((response) => {
          this.leiloes = response.data.leiloes;
          this.total = response.data.total;

          console.log("Leilões");
          console.log(this.leiloes);

          this.pagination(response.data);

          //CONVERTER STATUS
          for (let i = 0; i < this.leiloes.length; i++) {
            if (this.leiloes[i].leilao_oculto == 1) {
              this.leiloes[i].leilao_oculto = true;
            } else {
              this.leiloes[i].leilao_oculto = false;
            }

            if (this.leiloes[i].leilao_encerrado == 1) {
              this.leiloes[i].leilao_encerrado = true;
            } else {
              this.leiloes[i].leilao_encerrado = false;
            }

            if (this.leiloes[i].leilao_retirado == 1) {
              this.leiloes[i].leilao_retirado = true;
            } else {
              this.leiloes[i].leilao_retirado = false;
            }

            if (this.leiloes[i].leilao_suspenso == 1) {
              this.leiloes[i].leilao_suspenso = true;
            } else {
              this.leiloes[i].leilao_suspenso = false;
            }
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    getImagePath(logo) {
      return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + logo.path + "/" + logo.arquivo;
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          if (length - this.pagina_atual > 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarLeiloes();
    },

    deletar(leilao) {
      this.leilao_selecionado = leilao;

      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Deseja deletar o tipo de leilao<b><br/>" + this.leilao_selecionado.nome + "</b>? </h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              id: this.leilao_selecionado.id,
            };

            axios
              .post(`/admin/leilao/delete`, data)
              .then((response) => {
                this.showSuccessMessage("leilao deletado!");

                window.location.reload();
              })
              .catch((error) => {
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else {
        this.create();
      }
    },

    update() {
      this.isLoading = true;

      let data = {
        id: this.leilao_selecionado.id,
        cadastro_tipo: this.leilao_selecionado.cadastro_tipo,
        tipodoc: this.leilao_selecionado.tipodoc,
        estado_civil: this.leilao_selecionado.estado_civil,
        obrigatorio: this.leilao_selecionado.obrigatorio,
      };

      console.log("ATUALIZANDO");
      console.log(data);

      axios
        .post(`/admin/documento_tipo_usuario/update`, data)
        .then((response) => {
          this.showSuccessMessage("Estilo atualizado!");

          window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm");
    },
  },
};
</script>

<style scoped>
.modal-content {
  width: 1000px;
  margin-left: -150px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 800px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}
</style>
